import React, { Fragment } from "react";

import PayoutHistory from "../components/PayoutHistory";
import { OptionData } from "../shared/interfaces";
import variables from "../styleVariables";

interface Props {
  winner: OptionData;
  favorite: OptionData;
  options: Array<OptionData>;
  mobile: boolean;
}

const Histories = ({ winner, favorite, options, mobile }: Props) => {
  if (
    (options && options[0].history.length < 11) ||
    options[0].history === options[options.length - 1].history // Hide chart if favorite == longest chance
  ) {
    return null;
  } else if (!favorite) {
    return null;
  } else if (
    mobile &&
    window.innerWidth > parseInt(variables.mobileBreakpoint.replace("px", ""))
  ) {
    return null;
  } else if (
    !mobile &&
    window.innerWidth < parseInt(variables.mobileBreakpoint.replace("px", ""))
  ) {
    return null;
  } else {
    return (
      <Fragment>
        <h6 className="proposition__meta-h6">Odds History</h6>
        <PayoutHistory winner={winner} favorite={favorite} options={options} />
      </Fragment>
    );
  }
};

export default Histories;
